
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"43","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_0:1308)"}},[_c('path',{attrs:{"d":"M10.357 11.764h1.442V4.582H8.873v1.19h1.484v5.992zm6.169.126c1.89 0 3.178-1.12 3.178-2.702 0-1.162-.714-1.946-1.764-2.282.63-.294 1.106-.84 1.106-1.666 0-1.106-.952-2.128-2.52-2.128-1.54 0-2.52 1.022-2.52 2.128 0 .826.476 1.372 1.106 1.666-1.036.336-1.778 1.12-1.778 2.282 0 1.582 1.33 2.702 3.192 2.702zm0-5.516c-.658 0-1.12-.42-1.12-1.036 0-.63.476-1.05 1.12-1.05.644 0 1.12.42 1.12 1.05 0 .616-.462 1.036-1.12 1.036zm0 4.242c-1.036 0-1.694-.63-1.694-1.526 0-.91.658-1.582 1.694-1.582s1.694.672 1.694 1.582c0 .896-.658 1.526-1.694 1.526zm8.012 1.274c2.016 0 3.808-1.568 3.808-3.724 0-2.17-1.792-3.696-3.808-3.696-1.988 0-3.78 1.526-3.78 3.696 0 2.156 1.792 3.724 3.78 3.724zm0-1.274c-1.274 0-2.282-.994-2.282-2.45 0-1.47 1.008-2.436 2.282-2.436 1.302 0 2.31.966 2.31 2.436 0 1.456-1.008 2.45-2.31 2.45zm7.604-.938c1.498 0 2.702-1.106 2.702-2.604 0-1.484-1.203-2.604-2.702-2.604-1.498 0-2.702 1.12-2.702 2.604 0 1.498 1.204 2.604 2.702 2.604zm0-1.092c-.826 0-1.344-.616-1.344-1.512 0-.882.519-1.498 1.345-1.498.825 0 1.371.616 1.371 1.498 0 .896-.546 1.512-1.372 1.512z","fill":"#000"}}),_c('path',{attrs:{"opacity":".2","d":"M4.028 10.808C1.493 12.28 0 14.084 0 16.034 0 20.986 9.626 25 21.5 25S43 20.986 43 16.034c0-2.266-2.016-4.335-5.34-5.914","stroke":"#000"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_0:1308"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .764)","d":"M0 0h43v24.236H0z"}})])])])
          )
        }
      }
    